import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import { get_token, get_user_details } from "@/router";
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';
import GetCommunityAssets from '@/components/GetCommunityAssets/CommunityAsset.vue';
import Swal from 'sweetalert2';

export default {
  components: {
    Sidebar,
    Navbar,
    InactivityModal,
    GetCommunityAssets,
  },

  data() {
    return ({
      is_loading: false,
      community_assets: [],

      current_user_id: null,
      current_role: '',
      token_exists: false,
    });
  },

  mounted() {
    this.token_exists = !!this.get_token();
    try {
      const user = get_user_details();
      this.current_user_id = parseInt(user?.user_id, 10) || null;
      this.current_role = user?.user_role || '';
    } catch (_) {
      this.current_user_id = null;
      this.current_role = '';
    }

    this.fetch_community_assets();
  },

  methods: {
    get_token() {
      return get_token();
    },

    // -- Fetch list (no DataTables calls here; global script handles table init)
    fetch_community_assets() {
      this.is_loading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_community_asset/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.get_token()}`,
          'Content-Type': 'application/json'
        },
        success: (data) => {
          this.community_assets = Array.isArray(data?.community_assets) ? data.community_assets : [];
        },
        error: () => {
          this.community_assets = [];
        },
        complete: () => {
          this.is_loading = false;
        }
      });
    },

    // -- Actions (delegate to child where appropriate)
    select_asset(asset) {
      this.$refs.communityAssets?.select_asset(asset);
    },

    edit_asset(asset) {
      this.$refs.communityAssets?.edit_asset(asset);
    },
    asset_bookings(asset){
      this.$refs.communityAssets?.view_bookings(asset)
    },
    delete_asset(asset_id, evt) {
      if (evt) {
        evt.stopPropagation?.();
        evt.stopImmediatePropagation?.();
      }

      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (!result.isConfirmed) return;

        $.ajax({
          type: "DELETE",
          url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_community_asset/`,
          data: { community_asset_id: asset_id },
          headers: { 'Authorization': `Token ${this.get_token()}` },
          success: (response) => {
            if (response.status === "success") {
              Swal.fire({
                title: 'Deleted!',
                text: 'The Asset has been deleted.',
                icon: 'success',
                showConfirmButton: false,
                timer: 1000,
                position: 'bottom-end',
                toast: true
              });
              // remove locally; global datatable script will observe DOM and adjust
              this.community_assets = this.community_assets.filter(a => a.id !== asset_id);
              // optional: refresh child list if it maintains its own copy
              this.$refs.communityAssets?.fetchcommunity_assets?.();
            } else {
              Swal.fire({
                title: 'Failed!',
                text: response.message || 'An error occurred. Please try again.',
                icon: 'error',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          },
          error: (xhr) => {
            const resp = xhr.responseJSON || {};
            Swal.fire({
              title: 'Failed!',
              text: resp.message || 'An error occurred. Please try again.',
              icon: 'error',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
        });
      });
    },

    book_asset(asset) {
      if (this.$refs.communityAssets?.openBookingModal) {
        this.$refs.communityAssets.openBookingModal(asset);
      } else if (this.$refs.communityAssets?.view_bookings) {
        this.$refs.communityAssets.view_bookings(asset);
      }
    },

    toggle_sidebar() {
      this.$refs.sidebar?.$el.classList.toggle('close');
    },

    // ---------- (Optional) compatibility aliases ----------
    fetchcommunity_assets() { return this.fetch_community_assets(); },
    toggleSidebar() { return this.toggle_sidebar(); },
  },
};
